export default "__VITE_ASSET__C_A61Ul3__"